/**
 * InfinitSales - Notification Toaster
 * Mostra o card no canto (reusa SwipeToast) quando chega uma notificacao com
 * show_toast=true. Montado globalmente no App (dentro do NotificationsProvider).
 * Mesma posicao/estilo dos toasts que ja existem hoje.
 */
import React from 'react';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SwipeToast from './SwipeToast';
import { useNotifications } from '../../contexts/NotificationsContext';
import { routeOf } from '../../utils/channels';

const NotificationToaster = () => {
  const { currentToast, dismissToast } = useNotifications();
  const navigate = useNavigate();

  if (!currentToast) return null;

  // CTA "Ver conversa": navega pro inbox do canal com o chat alvo (o shell do
  // Inbox seleciona via location.state.openChat). Sem isto o botão só fechava.
  const handleCta = () => {
    const cta = currentToast.cta;
    if (cta?.action === 'open_chat' && cta.payload) {
      const { channel, chat_id, contact_phone, contact_igsid, contact_psid } = cta.payload;
      // Mesmo roteamento por canal do NotificationPanel: a rota vem do mapa
      // de canais (desconhecido = /inbox, o WhatsApp Pessoal).
      const rota = routeOf(channel);
      navigate(rota, {
        state: { openChat: { chat_id, contact_phone, contact_igsid, contact_psid, channel } },
      });
    }
    // "Abrir painel" (aviso de integração, ex.: portal pedindo login): mesmo
    // destino do clique no sino.
    if (cta?.action === 'open_url' && cta.payload?.url) {
      const url = cta.payload.url;
      if (/^https?:\/\//i.test(url)) window.open(url, '_blank', 'noopener,noreferrer');
      else navigate(url);
    }
    dismissToast();
  };

  return (
    <SwipeToast
      // key por id força reanimar a cada notificacao da fila
      key={currentToast.id}
      isOpen
      icon={<Bell size={18} />}
      title={currentToast.title}
      description={currentToast.body}
      ctaLabel={currentToast.cta?.label}
      onCta={handleCta}
      onDismiss={dismissToast}
      accentColor={currentToast.accent_color}
    />
  );
};

export default NotificationToaster;
